export default "__VITE_ASSET__DUmltkW9__"